// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const farfetchd_galar: PokeData = {
  "id": 10166,
  "name": "farfetchd-galar",
  "height": 8,
  "weight": 420,
  "base_experience": 132,
  "types": [
    PokeType.FIGHTING
  ],
  "api_moves": [
    "swords-dance",
    "slam",
    "sand-attack",
    "leer",
    "peck",
    "detect",
    "fury-cutter",
    "rock-smash",
    "brick-break",
    "knock-off",
    "leaf-blade",
    "brave-bird",
    "defog",
    "final-gambit",
    "brutal-swing"
  ],
  "moves": [
    "leer",
    "peck",
    "rock-smash",
    "brave-bird",
    "rolling-kick",
    "close-combat",
    "meteor-assault",
    "bulk-up",
    "karate-chop",
    "coaching",
    "drain-punch",
    "superpower",
    "jump-kick"
  ],
  "evolution_chain": {
    "id": 35,
    "item": null,
    "species": [
      {
        "name": "farfetchd",
        "order": 91,
        "types": [
          PokeType.NORMAL,
          PokeType.FLYING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "sirfetchd",
        "order": 865,
        "types": [
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": 83,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.THREE_CRITICAL_HITS
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 108,
    "speed": 107,
    "ability_power": 185
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": "galar"
} as const;
